var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"black_bg"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }